export const selectInput = {
  MuiSelect: {
    styleOverrides: {
      root: ({ theme }) => ({
        //
      }),
    },
  },
};
